import styled from 'styled-components';

import { colors } from '../../constants';

interface IProps {
    backgroundGrey?: boolean;
}

export const LineBackground = styled.div<IProps>`
    background: ${(props) =>
        props.backgroundGrey ? colors.greyDark : colors.white}
    height: 3px;
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
`;
